package utils

/**
 * LocalStorage utility functions for browser storage
 */

/**
 * Get an item from LocalStorage
 * @param key The key to retrieve
 * @return The value as a string, or null if not found
 */
fun getItem(key: String): String? {
    return js("try { return window.localStorage.getItem(key); } catch(e) { return null; }") as? String
}

/**
 * Set an item in LocalStorage
 * @param key The key to set
 * @param value The value to store (will be converted to string)
 */
fun setItem(key: String, value: String) {
    js("try { window.localStorage.setItem(key, value); } catch(e) { console.error('LocalStorage setItem error:', e); }")
}

/**
 * Remove an item from LocalStorage
 * @param key The key to remove
 */
fun removeItem(key: String) {
    js("try { window.localStorage.removeItem(key); } catch(e) { console.error('LocalStorage removeItem error:', e); }")
}
